<template>
  <VListItemAction v-if="actions.length" class="ml-1 mr-n1">
    <VMenu bottom left offset-y>
      <template #activator="{ attrs, on }">
        <VBtn x-small icon v-bind="attrs" v-on="on">
          <VIcon>fas fa-ellipsis-v</VIcon>
        </VBtn>
      </template>
      <VList>
        <VListItem
          v-for="(action, index) in actions"
          :key="index"
          :href="action.link"
          target="_blank"
          dense
        >
          {{ action.title }}
        </VListItem>
      </VList>
    </VMenu>
  </VListItemAction>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export interface ListItemAction {
  title: string
  // TODO: Update interface to be more flexible. Some actions may fire events and launch modals.
  link: string
}

export default defineComponent({
  props: {
    actions: {
      type: Array as PropType<ListItemAction[]>,
      required: true
    }
  }
})
</script>
